import React, { useEffect, useState } from "react";
import "./about.css";
import { trackPortfolioVisit, trackAboutEngagement } from "../../utils/analytics";

function About() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // Track when About section is loaded
    trackPortfolioVisit('about');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("card-in-view");
            // Track which about section card is viewed
            if (entry.target.classList.contains("card-Overview")) {
              trackAboutEngagement('overview_viewed');
            } else if (entry.target.classList.contains("card-TechStack")) {
              trackAboutEngagement('tech_stack_viewed');
            }
          } else {
            entry.target.classList.remove("card-in-view");
          }
        });
      },
      { threshold: 0.5 }
    );

    const elements = document.querySelectorAll(
      ".card-Overview, .card-TechStack"
    );
    elements.forEach((el) => observer.observe(el));

    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  const nextSlide = () => {
    setCurrentSlide(prev => prev === 0 ? 1 : 0);
  };

  const prevSlide = () => {
    setCurrentSlide(prev => prev === 1 ? 0 : 1);
  };

  return (
    <div>
      {/* ABOUT ME section */}
      <div className="center">
        <br />
        <br />
        <section id="about">
          <h1 className="heading">
            <span className="text autoplay"> ABOUT ME </span>
          </h1>
        </section>
      </div>

      <div className="cards-container">
        {/* Overview and picture of me card */}
        <div className="card-Overview">
          <br />
          <br />
          <img
            src="/images/Graduation_picture-removebg-preview.png"
            alt="Lusaduma Mata - Software Developer"
          />
          <p>
          I hold a Diploma in Information Technology in Software Development from IIE Rosebank College, obtained in 2023, 
          where I developed a strong foundation in software engineering principles, programming, and the full software development 
          lifecycle. I further strengthened my skills through the CapaCiTi Tech Career Accelerator, completing an 18-month Full Stack 
          Software Development programme that combined intensive training with industry exposure.<br></br><br></br>

          During this programme, I gained hands-on experience through placements at Younglings Africa and Liquid Intelligent Technologies, 
          where I worked on web and application development. I also served as an AWS Intern, focusing on cloud concepts, infrastructure, 
          and solutions, and earned the AWS Certified Cloud Practitioner certification, validating my foundational cloud knowledge.
          <br></br><br></br>

          Currently, I am working at IBM, where I am involved in Customer Value Management (CVM) and campaign execution. 
          My role includes supporting the design, testing, and implementation of SMS campaigns, working with campaign templates, 
          and translating business requirements into technical execution. This experience has given me exposure to enterprise systems 
          and campaign lifecycle processes, while continuing to develop my technical and analytical skills.
          </p>
        </div>

        {/* Technology Stack Section */}
        <div className="center">
          <section id="techstack">
            <h1 className="heading">
              <span className="text autoplay"> MY TECHNOLOGY STACK </span>
            </h1>
          </section>
        </div>

        {/* My skills card */}
        <div className="tech-stack-carousel-container">
          <div className="tech-stack-containers" style={{ transform: `translateX(${165 - (currentSlide * 330)}px)` }}>
            {/* Column 1: Frontend, Backend, Database */}
            <div className="card-TechStack">
            {/* Frontend */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Frontend</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
                    alt="HTML"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">HTML</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
                    alt="CSS"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">CSS</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
                    alt="JavaScript"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">JavaScript</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
                    alt="React"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">React</span>
                </div>
              </div>
            </div>

            {/* Backend */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Backend</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg"
                    alt="Node.JS"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Node.JS</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/supabase/supabase-original.svg"
                    alt="Supabase"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Supabase</span>
                </div>
              </div>
            </div>

            {/* Database */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Database</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg"
                    alt="SQL Server"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label" style={{ whiteSpace: 'nowrap' }}>SQL Server</span>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2: Cybersecurity, Programming, Cloud Platforms */}
          <div className="card-TechStack">
            {/* Cybersecurity */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Cybersecurity</h3>
                <div className="tech-item">
                  <span className="skill-tech-icon">🛡️</span>
                  <span className="tech-label">Anti-virus</span>
                </div>
                <div className="tech-item">
                  <span className="skill-tech-icon">🔥</span>
                  <span className="tech-label">Firewall</span>
                </div>
                <div className="tech-item">
                  <span className="skill-tech-icon">🔍</span>
                  <span className="tech-label">Monitoring</span>
                </div>
                <div className="tech-item">
                  <span className="skill-tech-icon">🔒</span>
                  <span className="tech-label">Security</span>
                </div>
              </div>
            </div>

            {/* Programming */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Programming</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg"
                    alt="Java"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Java</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg"
                    alt="Python"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Python</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
                    alt="React Native"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label" style={{ whiteSpace: 'nowrap' }}>React Native</span>
                </div>
              </div>
            </div>

            {/* Cloud Platforms */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Cloud Platforms</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg"
                    alt="AWS"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">AWS</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg"
                    alt="Azure"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Azure</span>
                </div>
              </div>
            </div>
          </div>

          {/* Column 3: IDEs, Mobile Development, Design Tool */}
          <div className="card-TechStack">
            {/* IDEs */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">IDEs</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg"
                    alt="Visual Studio Code"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">VS Code</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/androidstudio/androidstudio-original.svg"
                    alt="Android Studio"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Android Studio</span>
                </div>
              </div>
            </div>

            {/* Design Tool */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Design Tools</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg"
                    alt="Figma"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Figma</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/canva/canva-original.svg"
                    alt="Canva"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Canva</span>
                </div>
              </div>
            </div>

            {/* Mobile Development Tool */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Mobile Development</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/expo/expo-original.svg"
                    alt="Expo Go"
                    className="skill-tech-logo"
                    style={{ filter: 'invert(1)' }}
                  />
                  <span className="tech-label">Expo Go</span>
                </div>
              </div>
            </div>

            
          </div>

          {/* Column 4: Deployment & Hosting, Version Control, AI Tools */}
          <div className="card-TechStack">

            {/* AI Tools */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">AI Tools</h3>
                <div className="tech-item">
                  <img
                    src="/images/IBM Bob.png"
                    alt="IBM Bob"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">IBM Bob</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://github.githubassets.com/images/modules/site/copilot/copilot.png"
                    alt="GitHub Copilot"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">GitHub Copilot</span>
                </div>
                <div className="tech-item">
                  <img
                    src="/images/gamma.png"
                    alt="Gamma AI"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Gamma</span>
                </div>
                <div className="tech-item">
                  <img
                    src="/images/lovable.png"
                    alt="Lovable"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Lovable</span>
                </div>
              </div>
            </div>
            
            {/* Deployment & Hosting Platforms */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Deployment & Hosting</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/netlify/netlify-original.svg"
                    alt="Netlify"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label">Netlify</span>
                </div>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original-wordmark.svg"
                    alt="Vercel"
                    className="skill-tech-logo"
                    style={{ filter: 'invert(1)' }}
                  />
                  <span className="tech-label">Vercel</span>
                </div>
              </div>
            </div>

            {/* Version Control */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Version Control</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg"
                    alt="GitHub"
                    className="skill-tech-logo"
                    style={{ filter: 'invert(1)' }}
                  />
                  <span className="tech-label">GitHub</span>
                </div>
              </div>
            </div>

            
          </div>

          {/* Column 5: Google Tools */}
          <div className="card-TechStack">
            {/* Google Search Console */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Search Console</h3>
                <div className="tech-item">
                  <img
                    src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg"
                    alt="Google Search Console"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label" style={{ whiteSpace: 'nowrap' }}>Google Search Console</span>
                </div>
              </div>
            </div>

            {/* Google Analytics */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Google Analytics</h3>
                <div className="tech-item">
                  <img
                    src="https://www.gstatic.com/analytics-suite/header/suite/v2/ic_analytics.svg"
                    alt="Google Analytics"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label" style={{ whiteSpace: 'nowrap' }}>Analytics</span>
                </div>
              </div>
            </div>

            {/* Google Apps Script */}
            <div className="skill">
              <div className="skill-tech-icons">
                <h3 className="skill-name centered">Google Apps Script</h3>
                <div className="tech-item">
                  <img
                    src="https://www.gstatic.com/images/branding/product/1x/apps_script_48dp.png"
                    alt="Google Apps Script"
                    className="skill-tech-logo"
                  />
                  <span className="tech-label" style={{ whiteSpace: 'nowrap' }}>Apps Script</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Button */}
        <div className="carousel-navigation">
          {currentSlide === 0 ? (
            <button 
              className="carousel-btn"
              onClick={nextSlide}
              aria-label="View next technology stack"
            >
              <span className="carousel-arrow">→</span>
            </button>
          ) : (
            <button 
              className="carousel-btn"
              onClick={prevSlide}
              aria-label="View previous technology stack"
            >
              <span className="carousel-arrow">←</span>
            </button>
          )}
        </div>
        </div>
      </div>
      <br />
    </div>
  );
}

export default About;
